<template>
    <el-container v-wechat-title="title" :style="{ height: this.screenHeight - 115 + 'px', position: 'relative' }">
        <el-main class="width-p100" style="padding: 10px; margin-left: 10px; height: 100%; background: white" v-loading="loading">
            <div v-if="currentEmrRefUrl" style="text-align: left">
                <el-link v-if="isCustomProtocol" :href="currentEmrRefUrl" target="_blank" type="primary"><i class="el-icon-link"></i>报告详情</el-link>
                <iframe v-else frameborder="0" scrolling="auto" :src="currentEmrRefUrl" :height="this.screenHeight - 140" width="100%"></iframe>
            </div>
            <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5">
                <span class="el-icon-document"></span>
            </div>
        </el-main>
    </el-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AllOtherSystem`,
    props: {},
    data() {
        return {
            title: `360视图`,
            queryInput: ``,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            refUrl: this.$root.View360CtrlTabRefUrl,
            loading: false,
            surgeryInfo: {},
            visitInfo: {},
            hospitalward: {}
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        currentEmrRefUrl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.visitInfo) {
                _.each(this.visitInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }

            if (this.hospitalward) {
                _.each(this.hospitalward, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }

            if (this.surgeryInfo) {
                _.each(this.surgeryInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }

            console.log(refUrl)
            return refUrl
        },
        isCustomProtocol() {
            return !_.startsWith(this.currentEmrRefUrl, `http`)
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
    },
    mounted() {
        this.loadSurgery()
    },
    isjson(jsonstr) {
        if (typeof jsonstr == `string`) {
            try {
                var obj = JSON.parse(jsonstr)
                if (typeof obj == `object` && obj) {
                    return true
                } else {
                    return false
                }
            } catch (e) {
                return false
            }
        }
        return false
    },
    methods: {
        loadSurgery() {
            if (!this.surgeryId) {
                this.surgeryInfo = {}
                this.visitInfo = {}
                this.hospitalward = {}
                return
            }
            var that = this
            this.myaxios
                .get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                .then(data => {
                    let extrDatas = _.reduce(data.extra_datas, function(result, value, index) {
                        let flag = that.isjson(value.DataValue)
                        if (value.DataValue != `` && flag == true) {
                            result[value.DataKey] = value.DataExtraValue
                        } else {
                            result[value.DataKey] = value.DataValue
                        }
                        return result
                    }, {})
                    this.surgeryInfo = Object.assign(data, extrDatas)
                    this.visitInfo = data.visit_info
                    this.hospitalward = data.hospital_ward
                })
                .catch(e => {
                    console.log(e)
                })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadSurgery()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/AllOtherSystem/Index.vue